/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import { useHistory } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';

import PATH from 'constants/basePath';

import packageJson from '../../../package.json';

// Styles
import useStyles from './systemVersion.styles';

function SystemVersion() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Typography
      display='block'
      className={classes.versionText}
      variant='caption'
      onClick={() => history.push(PATH.CHANGELOG_HISTORY.BASE_URL)}>
      Versão: {packageJson.version}
    </Typography>
  );
}

export default SystemVersion;
export { SystemVersion };
